module.exports = __webpack_public_path__ + "static/media/payscale.8ef63db2.svg";